<div class="modal-small">
    <h4 class="mb-8">Confimration of changes</h4>
    <p class="body-2">Changing the outcome component will also affect the further steps of the AI analysis. Therefore, you will need to customize the import wizard:</p>
    <div class="d-flex align-items-center mt-24">
        <div class="number-circle"><span class="subtitle-2">4</span></div>
        <span class="subtitle-1">Aggregation</span>
    </div>
    <div class="mt-24">
        <button class="btn btn-primary mr-16">Continue</button>
        <button class="btn btn-secondary">Cancel</button>
    </div>
    <a class="btn-close material-icons-outlined">close</a>
</div>
